"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBlogNotificationEmails = exports.CreateBlogNotificationEmails = exports.deleteBlog = exports.DeleteBlog = exports.updateBlog = exports.UpdateBlog = exports.createBlog = exports.CreateBlog = exports.loadBlogs = exports.FetchBlogs = exports.CreateBlogNotificationEmailsActionTypes = exports.DeleteBlogActionTypes = exports.UpdateBlogActionTypes = exports.CreateBlogActionTypes = exports.FetchBlogsActionTypes = exports.BlogActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _actions = require("settings-ui-sdk/utils/actions");

var _errorMessagingJs = require("error-messaging-js");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _I18n = _interopRequireDefault(require("I18n"));

var ERROR_PREFIX_KEY = 'marketing.blog.errors';
var BlogActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_BLOGS: null,
  FETCH_BLOGS: null,
  UPDATE_BLOG: null,
  CREATE_BLOG: null,
  DELETE_BLOG: null,
  CREATE_BLOG_NOTIFICATION_EMAILS: null
}, 'blog');
exports.BlogActionTypes = BlogActionTypes;
var FetchBlogsActionTypes = (0, _actions.createRequestTypes)(BlogActionTypes.FETCH_BLOGS);
exports.FetchBlogsActionTypes = FetchBlogsActionTypes;
var CreateBlogActionTypes = (0, _actions.createRequestTypes)(BlogActionTypes.CREATE_BLOG);
exports.CreateBlogActionTypes = CreateBlogActionTypes;
var UpdateBlogActionTypes = (0, _actions.createRequestTypes)(BlogActionTypes.UPDATE_BLOG);
exports.UpdateBlogActionTypes = UpdateBlogActionTypes;
var DeleteBlogActionTypes = (0, _actions.createRequestTypes)(BlogActionTypes.DELETE_BLOG);
exports.DeleteBlogActionTypes = DeleteBlogActionTypes;
var CreateBlogNotificationEmailsActionTypes = (0, _actions.createRequestTypes)(BlogActionTypes.CREATE_BLOG_NOTIFICATION_EMAILS);
exports.CreateBlogNotificationEmailsActionTypes = CreateBlogNotificationEmailsActionTypes;
var FetchBlogs = (0, _actions.createRequestActions)(FetchBlogsActionTypes);
exports.FetchBlogs = FetchBlogs;
var loadBlogs = (0, _fluxActions.createAction)(BlogActionTypes.LOAD_BLOGS);
exports.loadBlogs = loadBlogs;
var CreateBlog = (0, _actions.createRequestActions)(CreateBlogActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateBlogActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.blog.notifications.createSuccess')));
  },
  failureMetaCreator: function failureMetaCreator(response) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(CreateBlogActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)((0, _errorMessagingJs.getTranslatedErrorMessage)({
      response: response,
      prefixKey: ERROR_PREFIX_KEY + ".create"
    })));
  }
});
exports.CreateBlog = CreateBlog;
var createBlog = (0, _fluxActions.createAction)(BlogActionTypes.CREATE_BLOG, (0, _actions.mapPayloadTo)('data'));
exports.createBlog = createBlog;
var UpdateBlog = (0, _actions.createRequestActions)(UpdateBlogActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateBlogActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.blog.notifications.saveSuccess')));
  },
  failureMetaCreator: function failureMetaCreator(response) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateBlogActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)((0, _errorMessagingJs.getTranslatedErrorMessage)({
      response: response,
      prefixKey: ERROR_PREFIX_KEY + ".update"
    })));
  }
});
exports.UpdateBlog = UpdateBlog;
var updateBlog = (0, _fluxActions.createAction)(BlogActionTypes.UPDATE_BLOG, (0, _actions.mapPayloadTo)('data'));
exports.updateBlog = updateBlog;
var DeleteBlog = (0, _actions.createRequestActions)(DeleteBlogActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DeleteBlogActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.blog.notifications.deleteSuccess')));
  },
  failureMetaCreator: function failureMetaCreator(response) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DeleteBlogActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)((0, _errorMessagingJs.getTranslatedErrorMessage)({
      response: response,
      prefixKey: ERROR_PREFIX_KEY + ".delete"
    })));
  }
});
exports.DeleteBlog = DeleteBlog;
var deleteBlog = (0, _fluxActions.createAction)(BlogActionTypes.DELETE_BLOG, (0, _actions.mapPayloadTo)('id', 'options'));
exports.deleteBlog = deleteBlog;
var CreateBlogNotificationEmails = (0, _actions.createRequestActions)(CreateBlogNotificationEmailsActionTypes);
exports.CreateBlogNotificationEmails = CreateBlogNotificationEmails;
var createBlogNotificationEmails = (0, _fluxActions.createAction)(BlogActionTypes.CREATE_BLOG_NOTIFICATION_EMAILS, (0, _actions.mapPayloadTo)('id'));
exports.createBlogNotificationEmails = createBlogNotificationEmails;